import { DatePipe } from '@angular/common';
import { BrokerTimeService } from 'src/app/services/broker-time.service';

/** Helpers compartidos por app-cartera, app-posiciones-broker y app-lista-ordenes. */

export function flattenArray(arrayOfArrays: any[]): any[] {
  return arrayOfArrays.flatMap(innerArray => innerArray);
}

export function agregaTiporModelo(data: any[]): any[] {
  return data.map(data => {
    if (data && typeof data.bajista === 'boolean') {
      const updatedOperation = {
        ...data,
        tipomodelo: data.bajista ? 'Bajista ↓' : 'Alcista ↑',
      };

      // Si 'bajista' es true, agrega la flecha hacia abajo al final de 'tipoOperacion'
      if (data.bajista && typeof data.tipoOperacion === 'string') {
        if (data.tipoOperacion === 'SALIDA') {
          updatedOperation.tipoOperacion = `ENTRADA ↓`;
        } else if (data.tipoOperacion === 'ENTRADA') {
          updatedOperation.tipoOperacion = `SALIDA ↓`;
        }
      } else if (!data.bajista && typeof data.tipoOperacion === 'string') {
        if (data.tipoOperacion === 'SALIDA' || data.tipoOperacion === 'ENTRADA') {
          updatedOperation.tipoOperacion = `${data.tipoOperacion} ↑`;
        }
      }

      return updatedOperation;
    } else {
      throw new Error("El objeto no tiene la propiedad 'bajista' o es un string.");
    }
  });
}

/** Hora (HH:mm:ss) de un timestamp en segundos; en MetaAPI usa la hora del servidor del broker. */
export function formatHoraCotizacion(timestamp: number, wallet: any, offsetMin: number | null,
  datePipe: DatePipe, brokerTimeService: BrokerTimeService): string {
  const date = new Date(timestamp * 1000);
  if (wallet?.tipoBroker === 'METAAPI') {
    return brokerTimeService.formatTime(date, offsetMin);
  }
  return datePipe.transform(date, 'HH:mm:ss') || '';
}

/** Fecha y hora de un timestamp (segundos o milisegundos); en MetaAPI usa la hora del servidor del broker. */
export function formatFechaHoraCotizacion(timestamp: number, wallet: any, offsetMin: number | null,
  datePipe: DatePipe, brokerTimeService: BrokerTimeService): string {
  if (timestamp === 0 || timestamp === undefined || timestamp === null) {
    return '';
  }
  // si el numero tiene menos de 13 digitos, lo multiplica por 1000 para convertirlo a milisegundos
  if (timestamp.toString().length < 13) {
    timestamp *= 1000;
  }
  const date = new Date(timestamp);
  if (wallet?.tipoBroker === 'METAAPI') {
    return brokerTimeService.formatDateTime(date, offsetMin);
  }
  return datePipe.transform(date, 'dd/MM/YYYY HH:mm:ss') || '';
}
